/* eslint-disable @typescript-eslint/no-explicit-any */
import { GeofenceCategory, GeofenceShape } from '@fleet-beat/api';

export interface CreateGeofenceModel {
  companyId: string;
  name: string;
  type: GeofenceCategory;
  geometryPolygon: GeometryPolygonModel;
  alertOnEnter: boolean;
  alertOnExit: boolean;
  shape: GeofenceShape;
}

export interface EditGeofenceModel {
  name?: string;
  type?: GeofenceCategory;
  geometryPolygon?: GeometryPolygonModel;
  alertOnEnter?: boolean;
  alertOnExit?: boolean;
  shape?: GeofenceShape;
  pointer?: string | null;
}

export interface GeometryPolygonModel {
  type: 'Polygon' | 'MultiPolygon';
  coordinates: any[][][];
}

export interface GeofenceDto {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  companyId: string;
  name: string;
  type: GeofenceCategory;
  geometryPolygon: GeometryPolygonModel;
  alertOnEnter: boolean;
  alertOnExit: boolean;
  dwellTime: number;
  shape: GeofenceShape;
  pointer: string | null;

  zoomIn?: boolean;
  trucksInZone?: number;
  hasPointerCoords?: boolean;
}

export interface GeofenceHistoryEventDto {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  geofenceId: string;
  truckId: string;
  state: 'entered' | 'exited';
  lat: number;
  lon: number;
  geofence: {
    name: string;
  };
  truck: {
    vehicleId: string;
    name: string | null;
  };
}
